<template>
  <hm-content title="">
    <div class="table-panel flex flex-end">
      <div>
        <el-input
          clearable
          v-model.trim="searchCondition.cardName"
          placeholder="请输入储值卡名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <!-- <el-input
          clearable
          v-model.trim="searchCondition.keyword"
          :placeholder="placeholder"
          size="small"
          style="width:300px"
          class="ipt mr10"
        >
          <el-select
            slot="prepend"
            style="width:100px"
            v-model="searchCondition.queryType"
            size="small"
            @change="selectQueryType"
          >
            <el-option label="商品货号" value="goodsSn"></el-option>
            <el-option label="商品条码" value="specBarcode"></el-option>
            <el-option label="商品名称" value="wxshopSpuName"></el-option>
          </el-select>
        </el-input> -->
        <el-input
          clearable
          style="width: 100px"
          type="number"
          v-model.trim="searchCondition.minCardDenomination"
          placeholder="最低"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-input
          clearable
          type="number"
          style="width: 100px"
          v-model.trim="searchCondition.maxCardDenomination"
          placeholder="最高"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <div>
      <el-table
        @sort-change="sortChange"
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardName"
          label="储值卡名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardDenomination"
          label="储值卡面额"
        >
          <template slot-scope="scope">
            <div class="primary">{{ scope.row.cardDenomination }}元</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="saleNum"
          label="已售数"
          sortable
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="useNum"
          label="已用尽数"
          sortable
        >
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="saleMoney"
          label="销售额"
          sortable
        >
          <template slot-scope="scope">
            <div class="primary">{{ scope.row.saleMoney }}元</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="useMoney"
          label="已使用余额"
          sortable
        >
          <template slot-scope="scope">
            <div class="primary">{{ scope.row.useMoney }}元</div>
          </template>
        </el-table-column>

        <el-table-column header-align="center" align="center" label="操作">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button size="small" type="text" @click="toDetails(scope.row)"
                >卡详情</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      width="80%"
      :visible.sync="dialogVisible"
    >
      <div slot="title" style="fontSize:16px">
        <span style="color:#222">储值卡详情</span>(<span class="blue"
          >{{ row.cardName }},面值{{ row.cardDenomination }}</span
        >)
      </div>
       <el-dialog
        width="900px"
        title="操作记录"
        :visible.sync="innerVisible"
        append-to-body>
        <el-table
          stripe
          border
          ref="table"
          :data="operList"
          style="width: 100%"
          size="small"
          max-height="500"
        >
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
            :index="index => index + (currentPageOper - 1) * pageSizeOper + 1"
          ></el-table-column>
             <el-table-column
            header-align="center"
            align="center"
            prop="cardName"
            label="储值卡名称"
          ></el-table-column>
             <el-table-column
            header-align="center"
            align="center"
            prop="memberName"
            label="持卡人姓名"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="cardNo"
            label="持卡人卡号"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="memberMobile"
            label="持卡人电话"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="operType"
            label="变更操作"
          >
          <template slot-scope="scope">
            <div v-if="scope.row.operType === 'frozen'" class="danger">
              冻结
            </div>
            <div v-else-if="scope.row.operType === 'unfreeze'" class="success">
              解冻
            </div>
          </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="operTime"
            label="变更时间"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="operName"
            label="操作人"
          ></el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="operTotal"
            @current-change="pagingOper"
            @size-change="handleSizeChangeOper"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPageOper"
          ></el-pagination>
        </div>
      </el-dialog>
      <div>
        <div class="flex flex-between mb10">
          <div>
            <el-button
              type="primary"
              size="small"
              @click="frozenAll('frozenAll')"
              :disabled="!detailsList.length"
              >全部冻结</el-button
            >
            <el-button
              type="primary"
              size="small"
              @click="frozenAll('okAll')"
              :disabled="!detailsList.length"
              >全部解冻</el-button
            >
          </div>
          <!-- <div>
            <el-input
              clearable
              style="width: 100px"
              type="number"
              v-model.trim="searchConditionDetails.minPrice"
              placeholder="最低"
              size="small"
              class="ipt mr10"
            ></el-input>
            <el-input
              clearable
              type="number"
              style="width: 100px"
              v-model.trim="searchConditionDetails.maxPrice"
              placeholder="最高"
              size="small"
              class="ipt mr10"
            ></el-input>
            <el-button type="primary" size="small" @click="searchDetails"
              >查询</el-button
            >
          </div> -->
        </div>
        <el-table
          v-if="detailsList.length"
          @sort-change="sortChangeDetail"
          stripe
          lazy
          :load="load"
          row-key="id"
          border
          class="mb20 modal-table"
          :header-cell-style="{ background: ' #f7f7f7', color: '#222' }"
          :data="detailsList"
          style="width: 100%"
          id="table"
          size="small"
        >
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            header-align="center"
            prop="memberName"
            label="持卡人"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="cardStatus"
            label="卡状态"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.level === 1">--</div>
              <div v-else>
                <div v-if="scope.row.cardStatus === 'frozen'" class="danger">
                  冻结
                </div>
                <div v-if="scope.row.cardStatus === 'lock'" class="blue">
                  锁定
                </div>
                <div v-if="scope.row.cardStatus === 'ok'" class="success">
                  正常
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="getNum"
            sortable
            label="赠送获得（张）"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="buyNum"
            sortable
            label="购买获得（张）"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="useNum"
            sortable
            label="已用尽（张）"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="useMoney"
            sortable
            label="消费金额"
          >
            <template slot-scope="scope">
              <div class="primary">{{ scope.row.useMoney }}元</div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="cardBalance"
            sortable
            label="剩余金额"
          >
            <template slot-scope="scope">
              <div class="primary">{{ scope.row.cardBalance }}元</div>
            </template>
          </el-table-column>
          <el-table-column header-align="center" align="center" label="操作">
            <template slot-scope="scope">
              <div class="flex flex-center">
                <el-button
                  size="small"
                  type="text"
                  class="success"
                  v-if="scope.row.cardStatus === 'frozen'"
                  @click="frozen(scope.row)"
                  :disabled="scope.row.cardStatus === 'lock'"
                >
                  解冻</el-button
                >
                <el-button
                  size="small"
                  type="text"
                  class="danger"
                  v-if="scope.row.cardStatus === 'ok'"
                  @click="frozen(scope.row)"
                  :disabled="scope.row.cardStatus === 'lock'"
                >
                  冻结</el-button
                >
                <el-button
                  size="small"
                  type="text"
                  class="blue"
                  v-if="scope.row.cardStatus === 'ok'||scope.row.cardStatus==='frozen'"
                  @click="info(scope.row)"
                >
                  操作记录</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="detailsTotal"
            @current-change="pagingDetail"
            @size-change="handleSizeChangeDetail"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPageDetail"
          ></el-pagination>
        </div>
        <span slot="footer" class="dialog-footer flex flex-center">
          <el-button @click="dialogVisible = false" size="small" type="info"
            >取 消</el-button
          >

          <!-- <el-button @click="dialogVisible = false" size="small">关闭</el-button> -->
        </span>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      innerVisible: false,
      currentPageOper: 1,
      pageSizeOper: 10,
      operList: [],
      operTotal: 0,
      searchConditionDetails: {},
      searchCondition: {},
      dialogVisible: false,
      currentPage: 1,
      pageSize: 10,
      list: [],
      total: 0,
      row: {},
      currentPageDetail: 1,
      pageSizeDetail: 10,
      detailsList: [],
      detailsTotal: 0,
      sort: {},
      sortDetail: {},
      cardStatus: "",
      rowOper: {}
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    async info(rowOper) {
      this.rowOper = rowOper;
      this.currentPageOper = 1;
      this.pageSizeOper = 10;
      this.queryOperList();
    },
    async queryOperList() {
      let params = {
        pageNo: this.currentPageOper,
        pageSize: this.pageSizeOper,
        cardRelId: this.rowOper.cardRelId
      };
      // const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      // Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "queryCardOperRecordList",
        params
      );
      if (code === "0") {
        const { records, total } = result;

        this.operList = records;

        this.operTotal = total;
        this.innerVisible = true;
      }
    },
    frozenAll(val) {
      if (val === "frozenAll") {
        this.cardStatus = "frozen";
      } else {
        this.cardStatus = "unfreeze";
      }
      this.frozenCard(this.row.cardId).then(code => {
        if (code === "0") {
          this.detailsList = [];
        }
      });
    },
    frozen(row) {
      if (row.cardStatus === "ok") {
        this.cardStatus = "frozen";
      } else if (row.cardStatus === "frozen") {
        this.cardStatus = "unfreeze";
      }
      this.frozenCard(row.cardId, row.cardRelId, row.centerId).then(code => {
        if (code === "0") {
          if (row.level === 1) {
            this.detailsList = [];
          } else {
            if (row.cardStatus === "ok") {
              row.cardStatus = "frozen";
            } else {
              row.cardStatus = "ok";
            }
          }
        }
      });
    },
    async frozenCard(cardId, cardRelId, centerId) {
      let params = {
        cardId: this.row.cardId,
        cardRelId,
        centerId,
        cardStatus: this.cardStatus
      };
      const { code } = await this.$store.dispatch(
        "frozenPrepayCardOrder",
        params
      );
      if (code === "0") {
        this.$message({
          message: " 操作成功",
          type: "success"
        });
        this.cardStatus = "";
        // this.detailsList = [];
        this.queryDetailList();
      }
      return code;
    },
    sortChange(sort) {
      this.sort = sort;
      this.queryList();
    },
    sortChangeDetail(sort) {
      this.sortDetail = sort;

      this.queryDetailList();
    },
    pagingDetail(page) {
      this.currentPageDetail = page;
      this.queryDetailList();
    },
    handleSizeChangeDetail(size) {
      this.currentPageDetail = 1;
      this.pageSizeDetail = size;
      this.queryDetailList();
    },
    searchDetails() {
      this.currentPageDetail = 1;
      this.queryDetailList();
    },
    load(tree, treeNode, resolve) {
      const { centerId } = tree;
      resolve([]);
      this.queryDetailByCenterList(centerId).then(res => {
        res.forEach(v => {
          v.id = v.cardRelId;
          v.level = 2;
        });

        resolve(res);
      });
    },
    async queryDetailByCenterList(centerId) {
      let params = {
        pageNo: this.currentPageDetail,
        pageSize: this.pageSizeDetail,
        cardId: this.row.cardId,
        order: this.sortDetail.order,
        prop: this.sortDetail.prop,
        centerId
      };
      const { result } = await this.$store.dispatch(
        "detailPrepayCardOrderByCenterId",
        params
      );
      return result.records;
    },
    async queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        order: this.sort.order,
        prop: this.sort.prop
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryPrepayCardOrderList",
        params
      );
      const { records, total } = result;

      this.list = records;

      this.total = total;
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    pagingOper(page) {
      this.currentPageOper = page;
      this.queryOperList();
    },
    handleSizeChangeOper(size) {
      this.currentPageOper = 1;
      this.pageSizeOper = size;
      this.queryOperList();
    },
    async queryDetailList(centerId) {
      let params = {
        pageNo: this.currentPageDetail,
        pageSize: this.pageSizeDetail,
        cardId: this.row.cardId,
        order: this.sortDetail.order,
        prop: this.sortDetail.prop,
        centerId
      };
      const searchCondition = JSON.parse(
        JSON.stringify(this.searchConditionDetails)
      );

      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "detailPrepayCardOrder",
        params
      );
      const { records, total } = result;
      records.forEach(v => {
        v.hasChildren = true;
        v.level = 1;
        v.id = v.centerId;
      });
      this.detailsList = records;
      this.detailsTotal = total;
      return this.detailsList;
    },
    toDetails(row) {
      this.detailsList = [];
      this.row = row;
      this.dialogVisible = true;
      this.queryDetailList();
      // this.$store
      //   .dispatch("detailPrepayCardOrder", { cardId: row.cardId })
      //   .then(res => {
      //     res.result.forEach(v => {
      //       v.isParent = true;
      //     });
      //     this.detailsList = res.result;
      //   });
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
